export const KRAAHL_CLIENT_HEADER = "x-kraahl-client" as const

export type ChatClientSource = "web" | "mobile" | "unknown"

export function resolveChatClientSource(headers: Headers): ChatClientSource {
  const raw = headers.get(KRAAHL_CLIENT_HEADER)?.trim().toLowerCase()
  if (raw === "web") return "web"
  if (raw === "mobile") return "mobile"
  return "unknown"
}
